import { PENDING_OUTREACH_DRAFTS_QUERY } from "@lib/graphql/outreach";
import { useOutreachListChannel } from "@lib/hooks/useOutreachListChannel";
import { useCallback } from "react";
import { useQuery } from "urql";
import { DraftRow } from "./DraftRow";
import type { OutreachDraft } from "./types";

interface Props {
  programmeId: string | null;
}

export function ApprovalQueueTab({ programmeId }: Props) {
  const [{ data, fetching }, reexecute] = useQuery({
    query: PENDING_OUTREACH_DRAFTS_QUERY,
    variables: { outreachProgrammeId: programmeId },
  });
  const refresh = useCallback(() => reexecute({ requestPolicy: "network-only" }), [reexecute]);
  useOutreachListChannel(refresh);

  const drafts: OutreachDraft[] = data?.pendingOutreachDrafts ?? [];

  if (fetching && drafts.length === 0) {
    return <p className="text-sm text-text-muted">Loading drafts…</p>;
  }

  if (drafts.length === 0) {
    return (
      <div className="rounded-lg border-2 border-dashed border-border-dashed p-8 text-center">
        <p className="text-sm text-text-muted">
          No drafts awaiting approval. Ask the chat agent to draft outreach once buyers are added.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {drafts.map((draft) => (
        <DraftRow key={draft.id} draft={draft} onChanged={refresh} />
      ))}
    </div>
  );
}
